import { ChangeDetectionStrategy, Component, computed, ElementRef, inject } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { lastValueFrom } from 'rxjs'
import { AdBannerService } from 'api'

@Component({
	selector: 'app-global-top-banner',
	standalone: true,
	imports: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'block fixed top-0 left-0 w-full z-[999]',
	},
	template: `
		<div class="w-full">
			@if (topBanner(); as banner) {
				@if (banner.targerUrl) {
					<a [href]="banner.targerUrl" target="_blank" rel="noopener noreferrer" class="block w-full">
						<img [src]="banner.imageIdList?.[0]?.fileUrl" [alt]="banner.title" class="w-full h-[65px] object-cover" />
					</a>
				} @else {
					<img [src]="banner.imageIdList?.[0]?.fileUrl" [alt]="banner.title" class="w-full h-[65px] object-cover" />
				}
			} @else {
				<img src="top-banner-defalt.gif" alt="بنر پیش‌فرض" class="w-full h-[65px] object-cover" />
			}
		</div>
	`,
})
export default class GlobalTopBannerComponent {
	private readonly el = inject(ElementRef)
	private readonly adBannerService = inject(AdBannerService)

	bannerList = injectQuery(() => ({
		queryKey: ['banner-list'],
		queryFn: () => lastValueFrom(this.adBannerService.getListAdBanner()),
		staleTime: 5 * 60 * 1000,
	}))

	topBanner = computed(() => {
		const banners = this.bannerList.data() ?? []
		return banners.find(b => b.placeMent === 'TOP-BANNER') ?? null
	})

	constructor() {
		if (typeof ResizeObserver !== 'undefined') {
			const ro = new ResizeObserver(entries => {
				for (const entry of entries) {
					const h = entry.contentRect.height
					document.documentElement.style.setProperty('--banner-h', `${h}px`)
				}
			})
			ro.observe(this.el.nativeElement)
		}
	}
}
